import { render, staticRenderFns } from "./page-more-component.vue?vue&type=template&id=1fefe156&scoped=true&"
import script from "./page-more-component.vue?vue&type=script&lang=js&"
export * from "./page-more-component.vue?vue&type=script&lang=js&"
import style0 from "./page-more-component.vue?vue&type=style&index=0&id=1fefe156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fefe156",
  null
  
)

export default component.exports